import PropTypes from 'prop-types';
import { USER_TYPES } from 'utils/types/user';
const { CURRENCY_TYPES, AUTH_STATE } = USER_TYPES;
export const CREDIT_WALLET_DATA = {
    credit: PropTypes.number, // 0 -- in pennies
    currencySymbol: PropTypes.string, // "$"
    currencyType: PropTypes.oneOf(Object.keys(CURRENCY_TYPES).map(key => CURRENCY_TYPES[key])), // "USD" - uppercase
    credits: PropTypes.string, // "US$13 | CA$34"
};
export const CREDIT_CARD_DATA = {
    externalId: PropTypes.string,
    type: PropTypes.string,
    last4: PropTypes.string,
    isDefault: PropTypes.bool,
    wallet: PropTypes.string,
};
export const PAYPAL_PAYMENT_DATA = {
    externalId: PropTypes.string.isRequired,
    paypalEmail: PropTypes.string.isRequired,
    wallet: PropTypes.string.isRequired,
};
export const VEHICLE_DATA = {
    id: PropTypes.number, // 6
    make: PropTypes.string,
    makeLabel: PropTypes.string,
    model: PropTypes.string,
    modelLabel: PropTypes.string,
    year: PropTypes.number,
    isDefault: PropTypes.bool, // false
};
export const USER_DATA = {
    creditCards: PropTypes.arrayOf(PropTypes.shape(CREDIT_CARD_DATA)),
    paypalCard: PropTypes.shape(PAYPAL_PAYMENT_DATA),
    creditWallets: PropTypes.objectOf(PropTypes.shape(CREDIT_WALLET_DATA)),
    dateJoined: PropTypes.string, // "2018-04-23T18:09:26.468866Z"
    displayName: PropTypes.string, // "Johanna Smith"
    email: PropTypes.string, // "johanna@test.com"
    firstName: PropTypes.string, // "Johanna"
    id: PropTypes.number, // 6
    isAdmin: PropTypes.bool, // false
    isSeller: PropTypes.bool, // false
    justCreated: PropTypes.bool, // false
    lastName: PropTypes.string, // "Smith"
    licensePlates: PropTypes.arrayOf(PropTypes.shape({
        licensePlateId: PropTypes.number,
    })),
    phoneNumber: PropTypes.string,
    referralToken: PropTypes.string, // "abc123"
    status: PropTypes.oneOf(Object.keys(AUTH_STATE).map(key => AUTH_STATE[key])), // "user"
    vehicles: PropTypes.arrayOf(PropTypes.shape(VEHICLE_DATA)),
};
